<template>
  <v-container v-if="fetchAgreementPending" fill-height>
    <v-row justify="center" align-center>
      <v-col text-center>
        <v-progress-circular
          v-bind:size="70"
          indeterminate
          class="primary--text"
        />
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else grid-list-md class="pa-0 ma-0">
    <v-row>
      <v-col :cols="12">
        <v-alert
          :value="agreement.status === 'VALID'"
          type="success"
        >
          {{ $t('texts.cooperationAgreementValid') }}
        </v-alert>
        <v-alert
          :value="agreement.status !== 'VALID'"
          type="error"
        >
          {{ $t('texts.cooperationAgreementInvalid') }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-card>
          <v-card-title>
            <v-icon class="mr-3">person</v-icon>
            <strong>{{ agreement.employee.first_name }} {{ agreement.employee.last_name }}</strong>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col :cols="12">
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="formattedItems"
              hide-default-footer
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState } = createNamespacedHelpers('user');
const { mapState: mapSecoState, mapActions: mapSecoActions } = createNamespacedHelpers('seco');

export default {
  name: 'SecoAgreementCheck',
  created() {
    this.fetchAgreement(this.$route.params.uuid);
  },
  computed: {
    ...mapUserState([
      'language',
    ]),
    ...mapSecoState([
      'agreement',
      'fetchAgreementPending',
    ]),
    headers() {
      const headers = [
        {
          text: this.$i18n.t('texts.title'), value: 'title', align: 'left', sortable: false,
        },
        {
          text: this.$i18n.t('texts.startOfWork'), value: 'formattedStartDate', align: 'left', sortable: false,
        },
        {
          text: this.$i18n.t('texts.endOfWork'), value: 'formattedEndDate', align: 'left', sortable: false,
        },
        {
          text: this.$i18n.t('texts.company.label'), value: 'company', align: 'left', sortable: false,
        },
      ];
      return headers;
    },
    formattedItems() {
      const agreements = [this.agreement.jobs.job1, this.agreement.jobs.job2];
      if (agreements.length > 0) {
        return agreements.map((item) => {
          const formattedStartDate = this.$options.filters.formatDateShort(item.start_date);
          const formattedEndDate = this.$options.filters.formatDateShort(item.end_date);
          const formattedItem = {
            ...item,
            formattedStartDate,
            formattedEndDate,
          };
          return formattedItem;
        });
      }
      return [];
    },
  },
  methods: {
    ...mapSecoActions([
      'fetchAgreement',
    ]),
  },
};
</script>
